"use client";

import { useEffect } from "react";
import posthog from "posthog-js";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // PostHog may not be initialized yet in global-error (outside layout)
    if (!posthog.__loaded) {
      posthog.init("phc_wz2NQRPGb6He9eZz2WWbFFwGqdbqFDYJH5fgYDzpoDW8", {
        api_host: "https://us.i.posthog.com",
        capture_exceptions: true,
      });
    }
    posthog.capture("$exception", {
      $exception_message: error.message,
      $exception_type: error.name,
      $exception_source: "global-error-boundary",
      severity: "fatal",
      digest: error.digest,
    });
  }, [error]);
  return (
    <html lang="en">
      <body style={{ background: "#0f1117", color: "#f1f5f9", fontFamily: "system-ui, sans-serif" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", padding: "1rem" }}>
          <div style={{ textAlign: "center", maxWidth: "28rem" }}>
            <h1 style={{ fontSize: "1.5rem", fontWeight: "bold", marginBottom: "1rem" }}>
              Something went wrong
            </h1>
            <p style={{ color: "#94a3b8", fontSize: "0.875rem", marginBottom: "1.5rem" }}>
              A critical error occurred. Please refresh the page.
            </p>
            <button
              onClick={reset}
              style={{
                padding: "0.5rem 1rem",
                borderRadius: "0.5rem",
                background: "#6366f1",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                fontSize: "0.875rem",
              }}
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
